import { ChangeEvent, forwardRef, useState } from 'react';
import { isSafeString } from '../form/schema/common';
import ErrorMessage from './ErrorMessage';
import Input, { InputProps } from './Input';

interface SafeInputProps extends InputProps {
    showError?: boolean; // whether to show validation error text
}

const SafeInput = forwardRef<HTMLInputElement, SafeInputProps>(({ showError = true, ...props }, ref) => {
    const [error, setError] = useState({ message: '' });

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        if (isSafeString(value)) setError({ message: '' });
        else {
            return;
            // setError({ message: 'Invalid or unsafe characters detected' });
        }

        if (props.onChange) props.onChange(e); // propagate to parent
    };

    return (
        <div>
            <Input {...props} ref={ref} onChange={handleChange} />
            {showError && <ErrorMessage error={error} />}
        </div>
    );
});

SafeInput.displayName = 'SafeInput';

export default SafeInput;
